<mmg-spinner></mmg-spinner>
<router-outlet></router-outlet>